export enum WebhookAdapterVersion {
  FIRST = "V1"
}

export enum WebhookStatuses {
  FAILED = "failed",
  PENDING = "pending",
  SUCCESS = "success"
}
